<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <h1 class="mb-2 text-center page-title">AVISO DE PRIVACIDAD</h1>

      <h6>1. Información Recopilada</h6>
      <p class="mb-2">
        Datos Personales: Recopilamos tu nombre completo, dirección de correo electrónico y número de teléfono para poder contactarte y brindarte información relevante.
        Información Demográfica: Recopilamos datos demográficos como tu edad, género y ubicación geográfica para comprender mejor a nuestra audiencia.
      </p>

      <br />
      <h6>2. Uso de la Información</h6>
      <p>
        La información recopilada se utiliza para:
      </p>
      <ul>
        <li>
          Personalizar tu experiencia y satisfacer tus necesidades.
        </li>
        <li>
          Enviar información relevante sobre nuestros productos/servicios.
        </li>
        <li>
          Mejorar nuestros productos/servicios según tus comentarios.
        </li>
        <li>
          Enviar comunicaciones promocionales y boletines informativos (si has optado por recibirlos).
        </li>
      </ul>

      <br />
      <h6>3. Seguridad de la Información</h6>
      <p>
        Tomamos medidas de seguridad razonables para proteger tus datos contra el acceso no autorizado, la divulgación, alteración o destrucción.
      </p>

      <br />
      <h6>4. Compartir Información</h6>
      <p>
        No compartimos tu información personal con terceros, excepto cuando sea necesario para cumplir con los fines mencionados anteriormente o cuando la ley lo requiera.
      </p>

      <br />
      <h6>5. Derechos del Titular de los Datos</h6>
      <p>
        Tienes derecho a acceder, rectificar, cancelar u oponerte al tratamiento de tus datos personales. Puedes ejercer estos derechos enviándonos una solicitud a [correo electrónico de contacto].
      </p>

      <br />
      <h6>6. Conservación de Datos</h6>
      <p>
        Conservaremos tus datos personales durante el tiempo necesario para cumplir con los fines para los cuales fueron recopilados.
      </p>

      <br />
      <h6>7. Cambios en la Política de Privacidad</h6>
      <p>
        Nos reservamos el derecho de modificar esta política en cualquier momento. Las actualizaciones se publicarán en nuestro sitio web.
      </p>
      <br />
      <p>
        Al completar este formulario, aceptas los términos y condiciones de este aviso de privacidad. Si tienes preguntas o inquietudes sobre nuestra política de privacidad, contáctanos a través de info@ppi.com.mx.
      </p>
      
      <br />
      <p>
        Fecha de última actualización:23/01/24
      </p>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/privacidad')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
